
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources } from './local';

try {
  i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: 'de',
      fallbackLng: 'de',
      supportedLngs: ['de', 'en', 'es'],
      interpolation: {
        escapeValue: false
      }
    });
} catch (error) {
  console.error('Failed to initialize i18n:', error);
  // Fallback to default language if initialization fails
  i18n.init({
    lng: 'de',
    fallbackLng: 'de',
    resources: { de: { translation: {} } }
  });
}

export default i18n;
